(function () {
    'use strict';
    function initVideoGalleryItem(media) {
    var video = media.querySelector('video');
    var playButton = media.querySelector('.video-gallery__play');
    if (!video || !playButton) { return; }
    var setPlayingState = function (isPlaying) {
    media.classList.toggle('is-playing', isPlaying);
    playButton.setAttribute('aria-label', isPlaying ? 'Pausar video' : 'Reproducir video');
    };
    playButton.addEventListener('click', function () {
    if (video.paused) { video.play().catch(function () {}); } else { video.pause(); }
    });
    video.addEventListener('play', function () { setPlayingState(true); });
    video.addEventListener('pause', function () { setPlayingState(false); });
    video.addEventListener('ended', function () { if (!video.loop) { setPlayingState(false); } });
    }
    function initVideoGalleryList(list) {
    var items = list.querySelectorAll('[data-video-item]');
    items.forEach(initVideoGalleryItem);
    var autoplayEnabled = list.dataset.autoplay === 'true';
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!autoplayEnabled || reduceMotion || !('IntersectionObserver' in window)) { return; }
    var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
    var video = entry.target.querySelector('video');
    if (!video) { return; }
    if (entry.isIntersecting) { video.play().catch(function () {}); } else { video.pause(); }
    });
    }, { threshold: 0.6 });
    items.forEach(function (media) { if (media.querySelector('video')) { observer.observe(media); } });
    }
    function initAllVideoGalleries(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-video-gallery-list]').forEach(initVideoGalleryList);
    }
    if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAllVideoGalleries(document); });
    } else {
    initAllVideoGalleries(document);
    }
    document.addEventListener('shopify:section:load', function (event) { initAllVideoGalleries(event.target); });
    })();
    